import React, { useState, useEffect } from 'react';
import RacerTimeRow from './RacerTimeRow';
import './leaderboard.css';

interface Racer {
	user: string
	timeString: string;
}

interface LeaderboardTimesProps {
	racers: Racer[];
	startRank?: number;
}

const RACERS_PER_COLUMN = 15;
const MOBILE_BREAKPOINT = 768;

export default function LeaderboardTimes({ racers, startRank = 4 }: LeaderboardTimesProps) {
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
		const handleChange = () => setIsMobile(mql.matches);
		handleChange();
		mql.addEventListener('change', handleChange);
		return () => mql.removeEventListener('change', handleChange);
	}, []);

	if (isMobile) {
		return (
			<div className="raceLeaderboardColumns raceLeaderboardColumns--single">
				<div className="raceLeaderboardColumn">
					{racers.map((racer, index) => (
						<RacerTimeRow
							key={racer.user}
							rank={startRank + index}
							userName={racer.user}
							timeString={racer.timeString}
						/>
					))}
				</div>
			</div>
		);
	}

	const columns: Racer[][] = [];
	for (let i = 0; i < racers.length; i += RACERS_PER_COLUMN) {
		columns.push(racers.slice(i, i + RACERS_PER_COLUMN));
	}

	return (
		<div className="raceLeaderboardColumns">
			{columns.map((columnRacers, colIndex) => (
				<div key={colIndex} className="raceLeaderboardColumn">
					{columnRacers.map((racer, index) => (
						<RacerTimeRow
							key={racer.user}
							rank={startRank + colIndex * RACERS_PER_COLUMN + index}
							userName={racer.user}
							timeString={racer.timeString}
						/>
					))}
				</div>
			))}
		</div>
	);
}
